
export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;
export const EXPIRED = '-expired';
export const CACHE_PATH_NAME = 'jhi-cachePathName';
export const AUTH_TOKEN_KEY = 'jhi-authenticationToken';
export const USER_PROFILE_KEY = 'jhi-userToken';
export const IDLE_SESSION_TIMEOUT_MINUTES = 15;
export const EXPIRED_CACHE_1_DAY = 24 * 60 * 60 * 1000;
export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const WHILELIST_ACCOUNT = process.env.REACT_APP_WHILELIST_ACCOUNT;